import React, { useState } from 'react';
import './comptePaiement.css';
import HeaderButton from 'utils/headerButton';
import CustomBootstrapTable from 'utils/reactTable';
import HeaderFirst from 'utils/HeaderFirst';
import { FormProvider, useForm } from 'react-hook-form';
import arrow from '../../image/arrow-left.png';
import { useNavigate, useParams } from 'react-router-dom';
import useComptePaiementData from './useCodeJournalData';
import { toast } from 'react-toastify';
import TablePaginators from 'components/Pagination/TablePaginator';
//import ModalExcel from 'pagesDossierClient/fournisseurs/ModalExcel/ModalExcel';
import ModalCodeJournal from './Modal';
import ButtonWhite from 'components/buttons/ButtonWhite';
import TableLoader from 'components/Loader/TableLoader';
import { useDossierRole } from 'contexts/DossierRoleContext';
//import { HiCloudUpload } from "react-icons/hi";


function ComptePaiements({ hideBack = false, embedded = false }) {
  const { canEdit, isCommercial } = useDossierRole();
  const { clientID: dossier_id } = useParams();
  const [searchTerm, setSearchTerm] = useState('');
  const [pageSize, setPageSize] = useState(10);
  const [paginationIndex, setPaginationIndex] = useState(0);
  const [selectedRows, setSelectedRows] = useState([]);
  const { updatedcomptePaiements, handleUpdateComptePaiement, handleDeleteComptePaiement, refetch, isLoading } =
    useComptePaiementData(dossier_id);

  const [viewArchived, setViewArchived] = useState(false);
  const navigate = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  //const [isModalFileOpen, setIsModalFileOpen] = useState(false)
  console.log({"Mes comptes paiement": updatedcomptePaiements});

  const filteredData = updatedcomptePaiements
    .filter((comptePaiement) =>
      viewArchived ? comptePaiement.archived : !comptePaiement.archived
    )
    .filter((comptePaiement) =>
      comptePaiement.compte.toLowerCase().includes(searchTerm.toLowerCase())
    );

  const currentPageData = filteredData.slice(
    paginationIndex * pageSize,
    (paginationIndex + 1) * pageSize
  );

  const handleActionSelected = (action) => {
    if (action === 'archive') {
      setViewArchived(!viewArchived);
    } else {
      console.log(`Action selected: ${action}`);
      // Handle other actions as necessary
    }
  };

  const handlePageChange = (newIndex) => {
    setPaginationIndex(newIndex);
  };

  const handleSearchChange = (newSearchTerm) => {
    setSearchTerm(newSearchTerm);
  };

  const handleRowSelect = (row, isSelect) => {
    if (isSelect) {
      setSelectedRows((prev) => [...prev, row.id]);
    } else {
      setSelectedRows((prev) => prev.filter((id) => id !== row.id));
    }
  };

  const onClickDetails = async () => {
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      const detailFournisseurURL = `details/${selectedRowId}/`;
      navigate(detailFournisseurURL);
    }
  };

  const onClickArchive = async () => {
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      const comptePaiement = updatedcomptePaiements.find(
        (f) => f.id === selectedRowId
      );
      if (!comptePaiement) {
        toast.error('compte Paiement non trouvé.');
        return;
      }

      try {
        await handleUpdateComptePaiement(selectedRowId, {
          archived: !comptePaiement.archived,
        });
        refetch();
        toast.info(
          `Mise à jour ${comptePaiement.archived ? 'désarchivé' : 'archivé'
          } avec succès.`
        );
      } catch (error) {
        toast.error(
          'Une erreur est survenue lors de la mise à jour du codeJournal.'
        );
      }
    } else {
      toast.warning(
        'Veuillez sélectionner exactement un codeJournal à archiver ou désarchiver.'
      );
    }
  };

  const onClickDelete = async () => {
    if (selectedRows.length === 1) {
      const selectedRowId = selectedRows[0];
      const comptePaiement = updatedcomptePaiements.find(
        (f) => f.id === selectedRowId
      );
      if (!comptePaiement) {
        toast.error('Code journal non trouvé.');
        return;
      }

      try {
        await handleDeleteComptePaiement(selectedRowId)
        refetch()
      } catch (error) {
        toast.error(
          'Une erreur est survenue lors de la mise à jour du codeJournal.'
        );
      }
    } else {
      toast.warning(
        'Veuillez sélectionner exactement un codeJournal à archiver ou désarchiver.'
      );
    }
  };

  const columns = [
    {
      dataField: 'compte',
      text: 'Compte',
      formatter: (cell) => <div>{cell}</div>,
    },
    {
      dataField: 'source_paiement',
      text: 'Source Paiement',
      formatter: (cell) => <div>{cell}</div>,
    },

  ];

  const handleDossierCreated = () => {
    setIsModalOpen(false);
    refetch(); 
  };

  const nom = (
    <div style={{ display: 'flex' }}>
      <h4 className="titre-dossier">{viewArchived ? 'Comptes de paiement archivés' : 'Mes comptes de paiement'}</h4>
      <span className="nbrDossier">{filteredData?.length}</span>
    </div>
  );

  const description = <div>{viewArchived ? 'Comptes de trésorerie archivés.' : 'Gérez vos comptes de trésorerie : caisse, banque et mobile money.'}</div>;


  const closeModal = () => {
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const methods = useForm();

  return (
    <div
      className="global"
      style={{
        backgroundColor: embedded ? 'transparent' : 'white',
        minHeight: '500px',
        borderRadius: '20px',
        padding: embedded ? '0' : '15px',
      }}
    >
      <div
        className="header mb-3"
        style={{
          backgroundColor: embedded ? 'transparent' : 'white',
          borderRadius: '10px',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          flexWrap: 'wrap',
        }}
      >
        {!embedded && <HeaderFirst nom={nom} description={description} hideBack={hideBack} />}
        {embedded && (
          <div className="d-flex align-items-center gap-2" style={{ flex: 1 }}>
            <span className="nbrDossier">{filteredData?.length} compte(s)</span>
          </div>
        )}
        {canEdit && !isCommercial && <ButtonWhite onClick={openModal} text="+ Ajouter un compte" />}

        {isModalOpen && (
          <FormProvider {...methods}>
            <ModalCodeJournal
              isOpen={isModalOpen}
              onClose={closeModal}
              onDossierCreated={handleDossierCreated}
              dossier_id={dossier_id}
            >
              <h2 style={{ color: '#009688', fontSize: '20px', fontWeight: 700 }}>
                <img src={arrow} alt="Arrow" />
                &nbsp;CREER UN NOUVEAU COMPTE
              </h2>
            </ModalCodeJournal>
          </FormProvider>
        )}
      </div>
      <HeaderButton
        placeholder={'Rechercher un code journal'}
        onSearchChange={handleSearchChange}
        isButtonsEnabled={selectedRows?.length > 0}
        onClickArchive={onClickArchive}
        onEyesClick={onClickDetails}
        onClickDelete={onClickDelete}
      />
      <div>
        {isLoading && (!updatedcomptePaiements || updatedcomptePaiements.length === 0) ? (
          <div style={{ background: '#ffffff', borderRadius: '12px', padding: '30px', border: '1px solid #e2eced' }}>
            <TableLoader
              message="Chargement des comptes de paiement..."
              subMessage="Récupération des comptes bancaires, caisses et opérateurs"
              minHeight="260px"
            />
          </div>
        ) : updatedcomptePaiements ? (
          <CustomBootstrapTable
            keyField="id"
            data={currentPageData}
            columns={columns}
            selectedRows={selectedRows}
            onSelectRow={handleRowSelect}
            wrapperClasses="table-wrapper"
          />
        ) : null}
      </div>
      {!isLoading && (!currentPageData || currentPageData.length === 0) && (
        <div className="d-flex justify-content-center fs-5 mt-4 text-muted">
          <p>Aucun compte de paiement à afficher.</p>
        </div>
      )}
      {updatedcomptePaiements && updatedcomptePaiements.length > 0 && (
        <TablePaginators
          paginationIndex={paginationIndex}
          setPaginationIndex={handlePageChange}
          dataLength={filteredData.length}
          pageSize={pageSize}
          setPageSize={setPageSize}
          onActionSelected={handleActionSelected}
          isViewingArchived={viewArchived}
        />
      )}

    </div>
  );
}

export default ComptePaiements;
